import { Device, MarketLocation } from '@e2m-customer-portal/hooks';
import { DowntimeModal } from '@e2m-customer-portal/ui';
import { Button } from '@mui/material';
import { ForecastProperty } from 'generated/graphql';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WarningIcon } from '../../assets/icons';

export interface DowntimeButtonProps {
  marketLocation: MarketLocation;
  device: Device;
  currentForecastProperty?: ForecastProperty;
  disabled?: boolean;
}

export function DowntimeButton({
  device,
  marketLocation,
  currentForecastProperty,
  disabled,
}: Readonly<DowntimeButtonProps>): ReactElement<DowntimeButtonProps> {
  const [open, setOpen] = useState(false);
  const [t] = useTranslation();

  return (
    <>
      {marketLocation && (
        <DowntimeModal
          open={open}
          marketLocation={marketLocation}
          device={device}
          currentForecastProperty={currentForecastProperty}
          onClose={(event) => {
            setOpen(false);
            event?.stopPropagation();
          }}
        />
      )}
      <Button
        className="w-max border-green-200 text-xs disabled:border-grey-200 sm:text-sm"
        color="primary"
        data-testid="DowntimeButton"
        variant="outlined"
        disabled={disabled}
        onClick={(event) => {
          setOpen(true);
          event?.stopPropagation();
        }}
      >
        <WarningIcon className="min-w-5" />
        <span className="ml-1 hidden sm:inline">{t('DOWNTIME_BUTTON')}</span>
      </Button>
    </>
  );
}
